/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelector } from "react-redux";
import { selectCurrentWebpage } from "data/store/reducers/webpage";

const useGetCurrentWebpage = function () {
    return useSelector(selectCurrentWebpage);
};

useGetCurrentWebpage.displayName = "useGetCurrentWebpage";
export { useGetCurrentWebpage };
